import React from 'react'
import { Toggle, Text } from 'components/base'

export default function SendActivityToSlackHeaderWithToggle({
  children,
  onToggle = () => {},
  checked = false,
  disabled = false,
  label = '',
  toggleLabels = undefined,
}) {
  return (
    <React.Fragment>
      <div className="flexbox flexbox-align-center margin-bottom-normal">
        <Text.Name className="margin-right-normal">{label}</Text.Name>
        <Toggle
          disabled={disabled}
          className="cursor"
          labels={toggleLabels}
          checked={checked}
          onChange={onToggle}
        />
      </div>
      {children}
    </React.Fragment>
  )
}
